"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skinToken = void 0;
var utils_1 = require("../../utils");
exports.skinToken = function (axios) {
    return {
        // git 토큰 목록 조회
        getSkinsSkinNoGitTokens: function (request) {
            var url = "/skins/" + request.pathParams.skinNo + "/git-tokens";
            return axios.get(url, request);
        },
        // git 토큰 생성
        postSkinsSkinNoGitTokens: function (request) {
            var url = utils_1.paramPathchange('/skins/{skinNo}/git-tokens', request);
            return axios.post(url, request.data);
        },
        // git 토큰 일괄 삭제
        deleteSkinsSkinNoGitTokens: function (request) {
            var url = utils_1.paramPathchange('/skins/{skinNo}/git-tokens', request);
            return axios.delete(url, request);
        }
    };
};
